import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/sample_sets/`, { params, cancelDuplicates: true });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/sample_sets/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/sample_sets/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/sample_sets/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/sample_sets/${data.id}`, data);
  },
  delete(projectId, id, params) {
    return Backend.delete(`/project/${projectId}/sample_sets/${id}`, { params });
  },
  listLabelSets(projectId, id) {
    return Backend.get(`/project/${projectId}/sample_sets/${id}`);
  },
};
